<template>
  <div id="ticket">
    <header>
      <div class="label">{{activityDetail.TicketSummary}}</div>
      <div class="img">
        <img
          :src="activityDetail.ActivityTilteImagePath !=null?activityDetail.ActivityTilteImagePath +'?x-oss-process=image/resize,m_pad,h_180,w_320,color_000000':defaultImg"
          :onerror="defaultImg"
          alt
        >
      </div>
    </header>
    <section>
      <h5>{{activityDetail.ActivityTitle}}</h5>
      <div class="info">
        地点：
        <span>{{activityDetail.ProvinceName}}{{activityDetail.CityName}}———{{activityDetail.ActivityAddress}}</span>
      </div>
      <div class="info">
        时间：
        <span>{{activityDetail.ActivityStartTime|formatDate}} ~ {{activityDetail.ActivityEndTime|formatDate}}</span>
      </div>
      <!-- <div class="info">
        有效期：
        <span>{{activityDetail.TicketEffectStartTime}} ~ {{activityDetail.TicketEffectEndTime}}</span>
      </div>-->
      <div class="code">
        <img :src="activityDetail.TicketQRCodePath" :onerror="defaultImg" alt>
      </div>
    </section>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
export default {
  components: {
    'footer-logo': footerLogo
  },
  data() {
    return {
      activityDetail: {},
      activeData: {
        applyId: this.$route.query.id
      },
      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
    }
  },
  created() {
    this.getMyActivityDetail()
  },
  methods: {
    getMyActivityDetail() {
      this.$fetch('/api/Activity/GetApplyTicketByApplyId', this.activeData).then(result => {
        this.isLoading = false
        this.activityDetail = result
      })
    }
  }
}
</script>
<style>
/* html,
  body,
  #app {
    height: auto !important;
  } */
</style>
<style lang="less" scoped>
header {
  width: 100%;
  height: 320 / @rem-size;
  background: url('../../assets/images/ticket-bc.png');
  background-size: 100% 100%;
  position: relative;

  .label {
    width: auto;
    padding: 0 6 / @rem-size;
    height: 60 / @rem-size;
    background: #ff9c00;
    color: #fff;
    font-size: 28 / @rem-size;
    border-top-left-radius: 8 / @rem-size;
    border-bottom-left-radius: 8 / @rem-size;
    text-align: center;
    line-height: 60 / @rem-size;
    position: absolute;
    top: 18 / @rem-size;
    right: 0;
  }

  .img {
    width: 640 / @rem-size;
    height: 360 / @rem-size;
    border-radius: 8 / @rem-size;
    overflow: hidden;
    position: absolute;
    top: 97 / @rem-size;
    left: 0;
    right: 0;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

#ticket {
  max-width: 750 / @rem-size;
  min-height: 100%;
  background: #fff;
  margin: 0 auto;
}

section {
  width: 100%;
  background: #fff;
  padding-top: 175 / @rem-size;
  padding-bottom: 40 / @rem-size;

  h5 {
    font-size: 36 / @rem-size;
    padding: 0 24 / @rem-size;
    color: #333;
    font-weight: normal;
    text-align: center;
  }

  .info {
    padding: 0 42 / @rem-size;
    font-size: 28 / @rem-size;
    color: #999;
    margin-top: 18 / @rem-size;

    span {
      color: #333;
    }
  }

  .code {
    width: 320 / @rem-size;
    height: 320 / @rem-size;
    margin: 0 auto;
    margin-top: 80 / @rem-size;
  }
}
</style>
